export enum PaymentMethod {
  DirectDeposit = 'DirectDeposit',
  Check = 'Check',
}
